const tokenKey = "adminAccessToken";
export function getAdminToken(): string | null { return sessionStorage.getItem(tokenKey); }
export function setAdminToken(token: string): void { sessionStorage.setItem(tokenKey, token); }
export function clearAdminToken(): void { sessionStorage.removeItem(tokenKey); }
export function isAdminAuthenticated(): boolean { return Boolean(getAdminToken()); }
